export default function () {
  this.loadContents()
}
